/**
 * E-commerce Integrations Index
 * Exports all e-commerce integration classes and utilities
 */

// Shopify Integration
export { ShopifyIntegration } from './ShopifyIntegration';
export { ShopifyIntegrationFactory } from './ShopifyIntegrationFactory';
export { registerShopifyIntegration } from './registerShopifyIntegration';

// WooCommerce Integration
export { WooCommerceIntegration } from './WooCommerceIntegration';
export { WooCommerceIntegrationFactory } from './WooCommerceIntegrationFactory';
export { registerWooCommerceIntegration } from './registerWooCommerceIntegration';

// Magento Integration
export { MagentoIntegration } from './MagentoIntegration';
export { MagentoIntegrationFactory } from './MagentoIntegrationFactory';
export { registerMagentoIntegration } from './registerMagentoIntegration';

// BigCommerce Integration
export { BigCommerceIntegration } from './BigCommerceIntegration';
export { BigCommerceIntegrationFactory } from './BigCommerceIntegrationFactory';
export { registerBigCommerceIntegration } from './registerBigCommerceIntegration';

// Types
export type {
  ShopifyConfig,
  ShopifyTokens,
  ShopifyProduct,
  ShopifyVariant,
  ShopifyOption,
  ShopifyImage,
  ShopifyCustomer,
  ShopifyAddress,
  ShopifyOrder,
  ShopifyLineItem,
  ShopifyMetafield,
  ShopifyCheckout
} from './ShopifyIntegration';

export type { ShopifyConnectionParams } from './ShopifyIntegrationFactory';

// WooCommerce Types
export type {
  WooCommerceConfig,
  WooCommerceProduct,
  WooCommerceCategory,
  WooCommerceTag,
  WooCommerceImage,
  WooCommerceAttribute,
  WooCommerceMetaData,
  WooCommerceCustomer,
  WooCommerceAddress,
  WooCommerceOrder,
  WooCommerceLineItem
} from './WooCommerceIntegration';

export type { WooCommerceConnectionParams } from './WooCommerceIntegrationFactory';

// Magento Types
export type {
  MagentoConfig,
  MagentoProduct,
  MagentoCustomer,
  MagentoOrder,
  MagentoAddress,
  MagentoOrderItem,
  MagentoCustomAttribute
} from './MagentoIntegration';

export type { MagentoConnectionParams } from './MagentoIntegrationFactory';

// BigCommerce Types
export type {
  BigCommerceConfig,
  BigCommerceProduct,
  BigCommerceCustomer,
  BigCommerceOrder,
  BigCommerceAddress,
  BigCommerceOrderProduct,
  BigCommerceProductImage,
  BigCommerceProductVariant
} from './BigCommerceIntegration';

export type { BigCommerceConnectionParams } from './BigCommerceIntegrationFactory';

// Re-export base types
export type {
  EcommerceProduct,
  EcommerceCustomer,
  EcommerceOrder,
  CartAbandonmentEvent,
  ProductViewEvent,
  RecommendationContext,
  ROIMetrics,
  ProductImage,
  ProductVariant,
  CustomerAddress,
  OrderLineItem
} from '../base/BaseEcommerceIntegration';

// Registration function to register all e-commerce integrations
export function registerAllEcommerceIntegrations(): void {
  // Import and call registration functions
  const { registerShopifyIntegration } = require('./registerShopifyIntegration');
  registerShopifyIntegration();
  
  const { registerWooCommerceIntegration } = require('./registerWooCommerceIntegration');
  registerWooCommerceIntegration();
  
  const { registerMagentoIntegration } = require('./registerMagentoIntegration');
  registerMagentoIntegration();
  
  const { registerBigCommerceIntegration } = require('./registerBigCommerceIntegration');
  registerBigCommerceIntegration();
}

// Auto-register integrations when this module is imported
registerAllEcommerceIntegrations();